import { render, staticRenderFns } from "./MaxWidthSection.vue?vue&type=template&id=1ea857e4&scoped=true&"
import script from "./MaxWidthSection.vue?vue&type=script&lang=ts&"
export * from "./MaxWidthSection.vue?vue&type=script&lang=ts&"
import style0 from "./MaxWidthSection.vue?vue&type=style&index=0&id=1ea857e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea857e4",
  null
  
)

export default component.exports